/**
 * @file コンポーネント：フル動画ページ手術情報 ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const OperativeInformation = (props) => {
    /**
     * スライダーカレント位置取得
     */
    const [arrayCurrentIndex, setArrayCurrentIndex] = useState(null);
    useEffect(() => {
        if (props.sliders.length > 0) {
            const result = props.sliders.map((slider) => {
                let currentIndex = 0;
                slider.forEach((slide, index) => {
                    if (slide.defaultFlg) {
                        currentIndex = index;
                    }
                });
                return currentIndex;
            });
            setArrayCurrentIndex(result);
        }
    }, [props.sliders]);

    /**
     * 編集モーダルに渡す処理対象DOMを指定
     */
    const refText = useRef(null);

    return (
        <Presenter
            {...props}
            arrayCurrentIndex={arrayCurrentIndex}
            refText={refText}
        />
    );
};
